import React from 'react';
import { Router, Route, Redirect, Switch } from 'react-router-dom';
import LayoutPage from "./reusable-components/Layout";
import Home from './containers/Home';
import ExtendVignete from './containers/ExtendVignete';
import NotFoundComponent from './containers/NotFound';
import ActivateVignete from './containers/ActivateVignete';
import { history } from './utils/helpers';

export default () => (
  <Router history={history} basename={'/pnh'}>
    <LayoutPage history={history}>
      <Switch>
        <Route path="/" exact component={Home} />
        <Route path="/extend" component={ExtendVignete} />
        <Route path="/activate" component={ActivateVignete} />
        <Route component={NotFoundComponent} />
      </Switch>
    </LayoutPage>
  </Router>
);
